<div class="ui modal " id="Terminal_Keyboard_Modal">
    <!--<div class="ui fluid icon action input" style="margin:10px">
        <input placeholder="Find Game" type="text" id="KeyboardSearch_Input" style="text-align:left" value="{{this.KeyboardSearch_Input_Value}}" />
        <button class="ui icon button" (click)="TerminalKeyboard_InputClear()">
            <i class="times circle outline large icon"></i>
        </button>

    </div>-->

    <div class="ui grid" style="margin:10px">

        <div style="padding:0">

            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(1)">
                1
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(2)">
                2
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(3)">
                3
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(4)">
                4
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(5)">
                5
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(6)">
                6
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(7)">
                7
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(8)">
                8
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(9)">
                9
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(0)">
                0
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('-')">
                -
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('_')">
                _
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('!')">
                !
            </button>
            
            <button class="circular ui icon button" style="margin:5px;height:44px;width:95px; border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="TerminalKeyboard_Backspace()">
                <i class="arrow left icon"></i>
            </button>
        </div>

        <div style="padding:0;padding-left:30px">
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('q')">
                q
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('w')">
                w
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('e')">
                e
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('r')">
                r
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('t')">
                t
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('z')">
                z
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('u')">
                u
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('i')">
                i
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('o')">
                o
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('p')">
                p
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('ü')">
                ü
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('?')">
                ?
            </button>
        </div>


        <div style="padding:0;padding-left:30px">
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('a')">
                a
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('s')">
                s
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('d')">
                d
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('f')">
                f
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('g')">
                g
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('h')">
                h
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('j')">
                j
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('k')">
                k
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('l')">
                l
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('ö')">
                ö
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('ä')">
                ä
            </button>
        </div>

        <div style="padding:0;padding-left:60px">
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('y')">
                y
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('x')">
                x
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('c')">
                c
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('v')">
                v
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('b')">
                b
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('n')">
                n
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('m')">
                m
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue(',')">
                ,
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('.')">
                .
            </button>
            <button class="Terminal_Setting_Keyboard_CircleButton" (click)="TerminalKeyboard_ChangeValue('')">
                '
            </button>
        </div>

        <div style="padding:0;padding-left:100px">

            <button class="circular ui icon button" style="margin:5px;height:44px;width:370px;float:left; border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="TerminalKeyboard_ChangeValue(' ')"></button>




            <button class="circular ui button" style="margin:5px;height:44px;width:95px;float:left;margin-left: 120px;border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="TerminalKeyboard_Close()">
                <span tkey="Close"></span>
            </button>
        </div>
    </div>
</div>
